import { BsPencil, BsTrash } from "react-icons/bs"
import { FunctionComponent, h } from "preact"
import { useEffect, useState } from "preact/hooks"

import AddKLHK from "./add-klhk"
import { BiMapPin } from "react-icons/bi"
import { Button } from "../../../parts/buttons"
import Container from "../../../parts/container"
import { Role } from "../../../enum/roles.enum"
import TopBar from "../../../components/topbar"
import TopFilter from "../../../components/TopFilter"
import useAllKlhk from "../../../hooks/useAllklhk"
import useAuth from "../../../hooks/useAuth"
import { useConfirm } from "../../../context/useConfirm"
import useMills from "../../../hooks/useMills"
import useModal from "../../../hooks/useModal"
import useObjectState from "../../../hooks/useObjectState"
import useTopFilter from "../../../hooks/useTopFilter"

type NCRKLHKPageProps = h.JSX.HTMLAttributes<HTMLDivElement>

const NCRKLHKPage: FunctionComponent<NCRKLHKPageProps> = () => {
  const filter = useTopFilter()
  const { data: klhk, mutate } = useAllKlhk(filter.output)
  const { isLogin } = useAuth()
  const { data: mills } = useMills()
  const [_, setMe] = useState<Role>(Role.Member)
  const confirmation = useConfirm()
  const { fetcher } = useAuth()
  const [selected, setSelected] = useObjectState({
    mil: "",
    isEdit: false,
    uuid: "",
    modal_status: "",
    edit_at: 0,
  })
  const { onHide, onShow, show } = useModal()
  useEffect(() => {
    isLogin().then((me) => {
      if (me) setMe(me.role)
    })
  }, [isLogin])
  const onBack = () => {
    setSelected({ isEdit: false })
    mutate()
  }
  const handleDeleteKlhk = (id: string) => {
    confirmation(
      "Are you sure you want to delete it?",
      (isDel) => {
        if (isDel)
          fetcher()
            .delete("/ncr-klhk/" + id)
            .then(() => {
              mutate()
            })
      },
      { yes: "Delete", no: "Cancel" }
    )
  }
  const handleUpdate = () => {
    onHide()
    if (selected.modal_status == "Closed")
      fetcher()
        .put("/ncr-klhk/validation/" + selected.uuid)
        .then(() => {
          mutate()
        })
  }
  if (selected.isEdit) return <AddKLHK uuid={selected.uuid} editAt={selected.edit_at} onBack={onBack} />
  return (
    <div>
      {/* modal */}
      <div
        className="modal-backdrop"
        style={{
          display: show ? "inherit" : "none",
          backgroundColor: "#00000099",
          overflowY: "auto",
        }}
      >
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
          <div class="modal-content card">
            <div className="card-body text-center h5">Report Status</div>
            <div className="card-body">
              <select
                className="form-control rounded-pill"
                onChange={({ currentTarget: e }) => setSelected({ modal_status: e.value })}
                value={selected.modal_status}
              >
                <option value="Open">OPEN</option>
                <option value="Closed">CLOSE</option>
              </select>
            </div>
            <div className="card-body d-flex justify-content-center">
              <Button onClick={onHide} variant="tertiary" className="m-1">
                Cancel
              </Button>
              <Button onClick={handleUpdate} variant="primary" className="m-1">
                Select
              </Button>
            </div>
          </div>
        </div>
      </div>
      <TopBar title="SPARING" subtitle="KLHK">
        <TopFilter hook={filter} />
        
      </TopBar>
      <Container>
        <div className="card">
          <div className="card-body">
            <div className="d-flex flex-row justify-content-between align-items-end">
              <div className="">
                <h3>KLHK</h3>
                <select
                  value={selected.mil}
                  onChange={({ currentTarget: e }) => setSelected({ mil: e.value })}
                  className="w-auto form-select rounded-pill"
                  id=""
                >
                  <option value="">All Mills</option>
                  {mills?.map((mil) => (
                    <option value={mil.uuid} key={mil.uuid}>
                      {mil.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="">
                <Button variant="primary" onClick={() => setSelected({ isEdit: true })} className="ms-2">
                  ADD NEW REPORT
                </Button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <table className="table table-striped table-center">
              <thead>
                <tr>
                  <th>Mills</th>
                  <th>Unit</th>
                  <th>Problem</th>
                  <th>Refinement Date</th>
                  <th>Status</th>
                  <th>Menu</th>
                </tr>
              </thead>
              <tbody>
                {klhk
                  ?.filter(({ mil }) => mil.uuid == selected.mil || !selected.mil)
                  .map((val) => (
                    <tr key={val.uuid}>
                      <td>{val.mil.name}</td>
                      <td>{val.cem.name}</td>
                      <td>{val.description}</td>
                      <td>{val.completion_date}</td>
                      <td>{val.status}</td>
                      <td>
                        <Button
                          className="me-2"
                          variant="secondary"
                          icon={BsPencil}
                          onClick={() => {
                            setSelected({
                              uuid: val.uuid,
                              isEdit: true,
                              edit_at: new Date().getTime(),
                            })
                          }}
                        />
                        <Button
                          className="me-2"
                          variant="tertiary"
                          onClick={() => handleDeleteKlhk(val.uuid)}
                          icon={BsTrash}
                        />
                        {val.status !== "Closed" && (
                          <Button
                            className="me-2"
                            variant="secondary"
                            onClick={() => {
                              setSelected({
                                uuid: val.uuid,
                                modal_status: val.status,
                              })
                              onShow()
                            }}
                            icon={BiMapPin}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="d-flex">
              <div className="ms-auto">{/* <Pagination /> */}</div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default NCRKLHKPage
